const DOMAIN_PATTERN = /^(\*\.)?[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
const DECIMAL_PATTERN = /^\d{1,3}$/;
const CIDR_PREFIX_PATTERN = /^\d{1,2}$/;
export const isValidDomain = (domain) => DOMAIN_PATTERN.test(domain);
export const isValidCidr = (cidr) => {
    const [ip, prefix, ...rest] = cidr.split('/');
    if (rest.length > 0 || ip === undefined || prefix === undefined)
        return false;
    if (!CIDR_PREFIX_PATTERN.test(prefix))
        return false;
    const prefixNumber = Number(prefix);
    if (prefixNumber < 0 || prefixNumber > 32 || String(prefixNumber) !== prefix)
        return false;
    const octets = ip.split('.');
    if (octets.length !== 4)
        return false;
    return octets.every((octet) => DECIMAL_PATTERN.test(octet) && Number(octet) <= 255 && String(Number(octet)) === octet);
};
const isValidIp = (ip) => isValidCidr(`${ip}/32`);
export const isValidNetworkDestination = (destination) => isValidDomain(destination) || isValidIp(destination) || isValidCidr(destination);
//# sourceMappingURL=networkPolicyValidation.js.map